import { CustomAxios } from "@shared/api/axiosClient";

import type { Schemas } from "@shared/api/types";

export type UserProfile = Schemas["UserProfileDTO"];
export type FieldsMetadata = Schemas["FieldsMetadataDTO"];

/**
 * Payload de cambio de contraseña. Sin tipo generado a proposito: el endpoint que consume
 * `changePassword` no existe en el backend (ver el comentario debajo).
 */
export interface ChangePasswordPayload {
  userId?: number;
  password?: string;
  newPassword?: string;
}

// Capa HTTP del dominio user-profile. Funciones puras: entran params,
// sale Promise<data>. Los headers de auth los adjunta el interceptor de axios compartido.

export const getUserProfile = (): Promise<UserProfile> =>
    CustomAxios.get("user-profile").then(({ data }) => data);

// OJO: este POST no tiene endpoint. `change-password` no aparece en ningun controller de
// `src/main/java` ni en el contrato capturado. Ademas el dialogo que lo dispara no se puede
// abrir: `setOpenDialog(true)` no se llama en ninguna parte. Funcionalidad doblemente
// muerta; darla de baja o implementarla es decision de producto.
export const changePassword = (payload: ChangePasswordPayload): Promise<unknown> =>
    CustomAxios.post("user/change-password", payload).then(({ data }) => data);

export const getProfileFieldsMetadata = (): Promise<FieldsMetadata> =>
    CustomAxios.get("user-profile/pickup-fields-metadata").then(({ data }) => data);

export const updateProfile = (payload: UserProfile): Promise<string> =>
    CustomAxios.post("user-profile", payload).then(({ data }) => data);
